import PersonIcon from "@mui/icons-material/Person";
import { Card, CardContent, Stack, Typography } from "@mui/material";

interface Props {
  shipment: PublicShipment | undefined;
}

// Shows the booked carrier on the public page. The backend only populates
// booked_carrier / booked_carrier_company in the transit phase (booked / picked
// up / delivered), so pre-booking pages render nothing here. Reads the company
// name straight from the payload — the public page is unauthenticated, so it
// cannot resolve the carrier via the authenticated company-profile fetch the
// in-app BookedCarrierSection uses.
export function PublicCarrierInformationSection(props: Props) {
  const { shipment } = props;

  if (!shipment?.booked_carrier || !shipment?.booked_carrier_company) {
    return null;
  }

  const carrierUser = shipment.booked_carrier.user;

  return (
    <Card sx={{ flex: 1, minWidth: "300px", boxShadow: 1 }}>
      <CardContent>
        <Stack direction="column" spacing={2}>
          <Stack direction="column" spacing={1}>
            <Typography variant="h6">Carrier</Typography>
            <Typography variant="body1" fontWeight="bold">
              {shipment.booked_carrier_company.name}
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={1}>
            <PersonIcon color="primary" fontSize="small" />
            <Typography variant="body1">
              {carrierUser.first_name} {carrierUser.last_name}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
